import React, { useState, useEffect, useRef } from 'react';
import '../../spinner.css';
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import Loader from '../../utility/Loader';
import { toast } from 'react-toastify';
import { getAllSearchResult } from '../../services/LearningService';
import { useLocation } from 'react-router-dom';

export default function LearnerSearch() {
    const location = useLocation();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {
            const query = new URLSearchParams(location.search).get('q');
            setSearchText(query);
            getAllSearchResultData(userDetails.token, query);
        }
    }, [location.search]);

    const getAllSearchResultData = async (token, query) => {
        if (query === '') {
            toast.warning("Search text is empty!");
            return;
        } else {
            setLoading(true);
            let resp = await getAllSearchResult(token, query);
            if (resp.error === false) {
                setSearchResults(resp.data);
                if (resp.data.length === 0) {
                    toast.warning(resp.message);
                }
            } else {
                toast.error(resp.message);
            }
            setLoading(false);
        }
    };

    const openLearningPage = async (module) => {
        if (module.module_type === 'ASSESSMENT') {
            sessionStorage.setItem("currentModule", JSON.stringify(module));
            navigate('/learner/assessment');
        } else if (module.module_type === 'THEORY') {
            sessionStorage.setItem("currentModule", JSON.stringify(module));
            navigate('/learner/video');
        } else if (module.module_type === 'GAME') {
            sessionStorage.setItem("currentModule", JSON.stringify(module));
            navigate('/learner/game');
        }
    };


    return (
        <>
            <div>
                {loading ? (
                    <Loader />
                ) : (
                    <div className='py-10'>
                        <div className='lg:px-12 px-6 lg:pb-2 pb-1 md:border-b-2 md:border-[#D0D0D0]'>
                            <h3 className='text-2xl text-secondary inter-700 mb-3 lg:hidden'>{module.course_name}</h3>
                            <div className='beardcrumb-wrap mb-5'>
                                <ul className='flex flex-wrap items-center'>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>My Courses</a>
                                    </li>
                                    <li className='current-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        Search
                                    </li>
                                </ul>
                            </div>
                            <div className='course-heading-wrap lg:mb-6 mb-5'>
                                {/* <h3 className='text-tertiary text-xl lg:text-2xl inter-500 mb-1'>Lesson {module.module_seq_no}</h3> */}
                                <h2 className='text-[#1D548D] text-2xl inter-500'>Results for "{searchText}" search</h2>
                            </div>

                        </div>
                        <div className='md:w-4/5 mx-auto pt-6'>
                            {searchResults.map((value, index) => (
                                <div key={index} className='srch-result-sngl md:py-10 py-6 md:border-b-1 md:border-[#D0D0D0]'>
                                    <h3 className='text-2xl 2xl:text-3xl text-black inter-600 md:mb-2 mb-1'>{value.course_name} - {value.module_name}</h3>
                                    <p className='text-lg text-[#7E7C7C] md:mb-4 mb-2'>{value.text.slice(0, 30)}</p>
                                    <button onClick={() => openLearningPage(value)} className='text-black hover:text-primary inter-600 text-lg 2xl:text-xl underline underline-offset-2 transition duration-300'>Click to View</button>
                                </div>
                            ))};
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}